/*
 *
 * Estos componentes estan presentes solo en el website
 *
 */

const page="./page/";
// import slick from 'vue-slick';
import BootstrapVue from 'bootstrap-vue';
import VueAwesomeSwiper from 'vue-awesome-swiper';
// import VueSweetalert2 from 'vue-sweetalert2';
import VCalendar from 'v-calendar'; // https://v2--vcalendar.netlify.app/
import SweetModal from 'sweet-modal-vue/src/plugin.js';
import loader from "vue-ui-preloader";

function plugin (Vue) {
	//Componentes llamados
  Vue.component('my-header', require(page+'shared/header.vue').default);
	Vue.component('my-footer', require(page+'shared/footer.vue').default);
	// Vue.component('slick',slick);
  Vue.use(BootstrapVue);
  Vue.use(VueAwesomeSwiper, /* { default options with global component } */);
  // Vue.use(VueSweetalert2);
  Vue.use(VCalendar, {
    // ...other defaults
  });
  Vue.use(loader);
  Vue.use(SweetModal);
  Vue.component('loading-component-s1', require(page+'shared/loading-component-s1.vue').default);
}

// Install by default if using the script tag
if (typeof window !== 'undefined' && window.Vue) {
  window.Vue.use(plugin)
}

export default plugin
